/**
 * The HOC component is used to extract prams from url
 * @author: Ronan
 * @param: propsMapping {array} param names in url and output prop key to wrapped component
 */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

const getPropsFromUrl = propsMapping => WrappedComponent => withRouter(class extends Component {
  mapParamsToProps = () => {
    const props = {};
    if (!_.isArray(propsMapping) || propsMapping.length < 1) {
      return props;
    }

    const { params } = this.props.match;
    propsMapping.forEach((p) => {
      // TODO: now we only support propsMapping as an array of strings, but we can support basic any kind of mapping, e.g. like [{ 'sourcePropName': 'targetPropName'}]
      if (_.isString(p)) {
        props[p] = params[p];
      }
    });
    return props;
  }

  render() {
    const props = {
      ...this.props,
      ...this.mapParamsToProps(),
    };
    return <WrappedComponent {...props} />;
  }
});

export default getPropsFromUrl;



// WEBPACK FOOTER //
// ./src/components/hoc/getPropsFromUrl.jsx